import React from "react";
import FaqSection from "./FaqSection.tsx";
import {
  salesPanels,
  technicalSupportPanels,
  operationsPanels,
} from "./DataFaq.tsx";

interface Props {
  searchValue?: string;
}

// Sales FAQ Section
const SaleFaqSec = ({ searchValue }: Props) => {
  return <FaqSection heading="Sales Related Queries" panels={salesPanels} searchValue={searchValue} />;
};

// Technical Support FAQ Section
const TechFaqSec = ({ searchValue }: Props) => {
  return (
    <FaqSection heading="Technical Support" panels={technicalSupportPanels} searchValue={searchValue} />
  );
};

// Operations FAQ Section
const OperationFaqSec = ({ searchValue }: Props) => {
  return (
    <FaqSection
      heading="Operations Related Queries"
      panels={operationsPanels}
      searchValue={searchValue}
    />
  );
};

export { SaleFaqSec, TechFaqSec, OperationFaqSec };
